import { html, ifDefined } from "../../"

import { isMobile } from "../../global/globals"
import type {
  HookFormCustomControlRender_Type,
  HookViewRowCellClass_ReturnType,
  HookViewRowCellClass_Type,
} from "../../global/hooks"
import {
  HookFormCustomControlRender,
  HookViewRowCellClass,
} from "../../global/hooks"

import { SYSFormElement } from "../../library/forms/sysformelement"
import {
  CachedRendererData,
  GetRendererFn,
  GetRowDisplayValue,
  _GetAlign,
} from "./helpers"
import type { DisplayMode, EditRowDef } from "./table"
import { _TableFormCloseEditRow } from "./tableapi"

let cachedRendererFn: Map<string, CachedRendererData> = new Map<
  string,
  CachedRendererData
>()

export class SYSTableRowForm extends SYSFormElement {
  props: any
  rowData: EditRowDef
  focusInit: boolean
  async init() {
    this.focusInit = false
    this.rowData = this.props()
    this.formType = "SYSTableRowEdit"
    this.formId = `${this.rowData.tableDef.id}_${this.rowData.key}`
    await super.init()
  }

  async connectedCallback() {
    this.addEventListener("keydown", this.handleKeyDown)
    await super.connectedCallback()
  }

  async disconnectedCallback() {
    this.removeEventListener("keydown", this.handleKeyDown)
    await super.disconnectedCallback()
  }

  handleKeyDown = async (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      _TableFormCloseEditRow(this.rowData.tableDef.id, this.rowData.key, {
        formState: this.formState,
        promptIfDirty: true,
      })
    }
  }

  // handleClick = async (e) => {
  //   let searchDataCol = e.target
  //   let key

  //   while (searchDataCol) {
  //     if (searchDataCol.getAttribute("data-col")) {
  //       key = searchDataCol.getAttribute("data-col")
  //       break
  //     }
  //     searchDataCol = searchDataCol.parentNode
  //   }

  //   if (key) {
  //     let def = this.rowData.tableDef
  //     let functionName = HookFieldRowCellSelectedHandler.replace(
  //       "{subFeature}",
  //       this.formState.subFeature
  //     ).replace("{fieldKey}", key)
  //     let fn = this.actions.app.features[def.feature]
  //     if (fn?.hooks?.[functionName]) {
  //       if (
  //         !(await fn.hooks[functionName](<HookFieldRowCellSelectedHandler_Type>{
  //           e,
  //           def,
  //           data: this.rowData.data,
  //           rowKey: this.rowData.key,
  //           displayMode: <DisplayMode>"EditInline",
  //           formState: this.formState,
  //           row: this.rowData.row,
  //         }))
  //       ) {
  //         return
  //       }
  //     }
  //   }
  // }

  async getUI() {
    let def = this.rowData.tableDef
    let fields = this.formState.fields

    let customRowCellClasses: HookViewRowCellClass_ReturnType
    let functionName = HookViewRowCellClass.replace(
      "{subFeature}",
      this.formState.subFeature
    )
    let fn = this.actions.app.features[def.feature]
    if (fn?.hooks?.[functionName]) {
      customRowCellClasses = fn.hooks[functionName](<HookViewRowCellClass_Type>{
        columns: def.columns,
        row: this.rowData.row,
        rowKey: this.rowData.key,
        isMobile: isMobile(),
        displayMode: <DisplayMode>"EditInline",
        feature: def.feature,
        tableDefId: def.id,
        def,
      })
    }
    let columns = def.columns
    //let firstEditable = false
    return html`
      ${Object.keys(columns).map((k) => {
        let customRowCellClass: string = ""
        let draggable =
          customRowCellClasses?.[k]?.draggable === true ? true : undefined
        let tooltip = customRowCellClasses?.[k]?.tooltip
        if (!tooltip) {
          tooltip = undefined
        }
        if (customRowCellClasses?.[k]?.className) {
          customRowCellClass = customRowCellClasses[k].className
        }

        let col = columns[k]
        let uiItem

        let rendererFn = GetRendererFn(
          def.feature,
          cachedRendererFn,
          HookFormCustomControlRender.replace(
            "{subFeature}",
            this.formState.subFeature
          ),
          k
        )

        let id = this.rowData.key + "ovlRFNFocus_" + k

        let colRenderState = def.uiState.columnsRenderingState.columns
        let columnsVisible = def.uiState.columnsRenderingState.visibleInTable
        let isVisibleEdit = colRenderState[k].visibility.indexOf("Edit") > -1
        let align = ""
        if (!isVisibleEdit && !(columnsVisible.indexOf(k) > -1)) {
          return null
        } else if (!isVisibleEdit && columnsVisible.indexOf(k) > -1) {
          uiItem = ""
        } else if (rendererFn) {
          uiItem = rendererFn(<HookFormCustomControlRender_Type>{
            field: fields[k],
            formState: this.formState,
            id,
          })
          // } else if (col.ui.readonly) {
          //   uiItem = GetRowDisplayValue(
          //     def,
          //     k,
          //     this.rowData.row,
          //     this.rowData.key,
          //     "Table"
          //   )
          //   align = _GetAlign(col.ui.align)
        } else {
          switch (col.control) {
            case "text":
              uiItem = html`
                <ovl-textbox class="fd-form__item " .props=${() => fields[k]}>
                </ovl-textbox>
              `
              break
            case "date":
              uiItem = html`
                <ovl-datebox class="fd-form__item " .props=${() => fields[k]}>
                </ovl-datebox>
              `
              break

            case "time":
              uiItem = html`
                <ovl-timebox class="fd-form__item " .props=${() => fields[k]}>
                </ovl-timebox>
              `
              break

            case "textarea":
              uiItem = html`
                <ovl-textarea class="fd-form__item " .props=${() => fields[k]}>
                </ovl-textarea>
              `
              break
            case "list":
              {
                uiItem = html`
                  <ovl-listcontrol
                    class="fd-form__item "
                    .props=${() => fields[k]}
                  >
                  </ovl-listcontrol>
                `
              }
              break
            case "asset":
              {
                uiItem = html`
                  <ovl-asset class="fd-form__item " .props=${() => fields[k]}>
                  </ovl-asset>
                `
              }
              break

            case "checkbox":
              {
                uiItem = html`
                  <ovl-checkbox
                    class="fd-form__item "
                    .props=${() => fields[k]}
                  >
                  </ovl-checkbox>
                `
              }
              break
          }
        }

        return html`
          <td
            title=${ifDefined(tooltip)}
            draggable=${ifDefined(draggable)}
            data-col=${k}
            class="fd-table__cell ${align} ovl-tableedit-rowcell ${customRowCellClass}"
          >
            ${uiItem}
          </td>
        `
      })}
    `
  }
}
